/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  };

  var addColorSwatch = function addColorSwatch(currentColor) {
    var html_color_swatch = ``;

    var colorMappings = window.theme.algolia.colorMappings;
    colorMappings.forEach(color => {
      var colorParts = color.split("|");
      var colorName = colorParts[0].toLowerCase().trim();
      var colorTranslation = colorParts[1].toLowerCase().trim();
      var colorHex = colorParts[2].toLowerCase().trim();


      if (colorName === currentColor) {
        var html_filter_border_inner = `
          <i class="icon-wrapper icon-filter_border color_inner" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <path fill="${colorHex}" fill-rule="evenodd" stroke="${colorHex}" stroke-opacity="1" d="M24.142 28.31c1.93-1.368 3.479-3.25 4.57-5.308 2.986-5.635 3.583-13.56-1.476-18.409-2.463-2.36-6.12-3.14-9.596-3.455-2.756-.251-5.643-.258-8.16.842C6.176 3.423 4.03 6.54 2.565 9.713c-.956 2.072-1.71 4.303-1.543 6.561.104 1.41.563 2.775 1.152 4.071 1.606 3.534 4.282 6.693 7.819 8.55 3.537 1.858 7.96 2.301 11.67.784.884-.361 1.711-.825 2.478-1.369"/>
            </svg>
          </i>
        `;

        var html_filter_border_outer = `
          <i class="icon-wrapper icon-filter_border color_outer" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <path fill="" fill-rule="evenodd" stroke="" stroke-opacity="1" d="M24.142 28.31c1.93-1.368 3.479-3.25 4.57-5.308 2.986-5.635 3.583-13.56-1.476-18.409-2.463-2.36-6.12-3.14-9.596-3.455-2.756-.251-5.643-.258-8.16.842C6.176 3.423 4.03 6.54 2.565 9.713c-.956 2.072-1.71 4.303-1.543 6.561.104 1.41.563 2.775 1.152 4.071 1.606 3.534 4.282 6.693 7.819 8.55 3.537 1.858 7.96 2.301 11.67.784.884-.361 1.711-.825 2.478-1.369"/>
            </svg>
          </i>
        `;

        var html_mix_border_inner = `
          <i class="icon__color-mix" style="background-image: url('${window.theme.algolia.assetMixImage}');"></i>
        `;

        if (colorHex.indexOf("mix") > -1) {
          html_color_swatch = `
            ${html_filter_border_outer}
            ${html_mix_border_inner}
          `;
        } else {
          html_color_swatch = `
            ${html_filter_border_outer}
            ${html_filter_border_inner}
          `;
        }
      };
    });

    return html_color_swatch;
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },

    setColorFacetClass: function setColorFacetClass(text, render) {
      if (render(text).indexOf("edelsteen") > -1 || render(text).indexOf("edelstein") > -1 || render(text).indexOf("gemstone") > -1) {
        return render('filter-list-item__color');
      }
    },

    isColorFacet: function isColorFacet(text, render) {
      if (render(text).indexOf("edelsteen") > -1 || render(text).indexOf("edelstein") > -1 || render(text).indexOf("gemstone") > -1) {

        var el = document.querySelectorAll(`[data-ais-custom-tag="${this.label}"]`);
        return addColorSwatch(this.label.toLowerCase());
      }
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function (size) {
    algolia.helpers[size + 'Image'] = (function (_size) {
      return function () {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function () {
      return function (text) {
        var render = function (value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
